<template>
  <transition name="slide">
    <div v-if="sideopened" class="sidebar">
      <div class="sidebar-panel">
        <div class="headerDetail">
          <h5>Data</h5>
          <button
              :title="$t('CLOSE_DETAILS')"
              class="close"
              @click="closeSidebarPanel">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['sideopened'],
  data: function () {
    return {
      'width': {
        default: '20em',
      }
    };
  },
  methods: {
    closeSidebarPanel() {

      //this.sideopened = false
      this.$emit('toggle-sidebar', false);
    },
    beforeEnter(el) {
      el.style.marginLeft = '-20em';
    },
    enter(el) {
      setTimeout(() => {
        el.style.marginLeft = '0';
      }, 0);
    },
    leave(el) {
      el.style.marginLeft = '-20em';
    },
  },
};
</script>
<style>

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear; /*je veux que tu fasse la transition sur transform ou opacity... pour 0.5s*/
  /* transition: transform 0.5s, opacity 0.5; */ /*possible aussi*/
}


.slide-leave-to {
  transform: translateX(-100%);
  transition: all 350ms ease-out 0s;
}

.slide-enter {
  transform: translateX(-10%);
}

.sidebar {
  overflow-y: scroll;
}

.sidebar-panel {
  /* overflow-y: auto; */
  background-color: #efefef;
  height: 85vh;
  padding: 0.5rem;
}

.headerDetail {
  display: flex;
  justify-content: space-between;
  padding: 0.3rem;
  font-family: "Segoe UI";
}

.close {
  float: right;
  font-size: 1.2rem !important;
}
</style>